const PLAYBACK_AREA_COORDINATES = [
  //北西
  [130.8348067581409, 30.781624146233714],
  [130.8348067581409, 30.69988227513306],
  [131.0094514167177, 30.69988227513306],
  [131.0094514167177, 30.781624146233714],
  [130.8348067581409, 30.781624146233714],
];

const PLAYBACK_AREA_DEFAULT_ZOOM = 13;

const PLAYBACK_OBJECT_TYPE = {
  MY_VESSELS: 1,
  OTHER_VESSELS: 2,
  RG_OBJECT: 3,
  PRIVATE_PLOT: 4,
};

const RADAR_GRID_OBJECT_KIND = {
  SHIP: "ship",
};

const RG_RISK_LEVEL = {
  SAFE: 0,
  CAUTION: 5,
  DANGER: 10,
};

const RG_RISK_LEVEL_CANCELED = 99;

const RADAR_GRID_OBJECT_RISK_LEVEL = {
  [RG_RISK_LEVEL.SAFE]: {
    label: "safe",
    labelJa: "安全",
    color: "#0ED463",
    blinkColor: "rgb(14, 212, 99)",
    brinkIconId: "rg-icon-blink-safe",
    brinkOtherKindIconId: "rg-icon-blink-target-safe",
    frameIconId: "rg-icon-frame-safe",
  },
  [RG_RISK_LEVEL.CAUTION]: {
    label: "caution",
    labelJa: "注意",
    color: "#EFF335",
    blinkColor: "rgb(242, 246, 28)",
    brinkIconId: "rg-icon-blink-caution",
    brinkOtherKindIconId: "rg-icon-blink-target-caution",
    frameIconId: "rg-icon-frame-caution",
  },
  [RG_RISK_LEVEL.DANGER]: {
    label: "danger",
    labelJa: "危険",
    color: "#F23D3D",
    blinkColor: "rgb(235, 87, 87)",
    brinkIconId: "rg-icon-blink-danger",
    brinkOtherKindIconId: "rg-icon-blink-target-danger",
    frameIconId: "rg-icon-frame-danger",
  },
};

const LAYER_ID = {
  RG_DISPLAY_AREA_LAYER: "rg-display-area-layer",
  RG_HISTORY_TRACK_LAYER: "rg-history-track-layer",
  RG_HISTORY_TRACK_HOVER_EVENT_LAYER: "rg-history-track-hover-event-layer",
  RG_VESSEL_SYMBOL_LAYER: "rg-vessel-symbol-layer",
  RG_VESSEL_POLYGON_LAYER: "rg-vessel-polygon-layer",
  RG_VESSEL_NO_POLYGON_LAYER: "rg-vessel-no-polygon-layer",
  RG_VESSEL_TEXT_LAYER: "rg-vessel-text-layer",
  RG_VESSEL_MARKER_LAYER: "rg-vessel-marker-layer",
  RG_OBJECT_SYMBOL_LAYER: "rg-object-symbol-layer",
  RG_OBJECT_FLAME_LAYER: "rg-object-flame-layer",
  RG_OBJECT_CIRCLE_LAYER: "rg-object-circle-layer", // オブジェクト選択時の円
  RG_OBJECT_WAKE_LAYER: "rg-object-wake-layer",
  RG_OBJECT_WAKE_HOVER_EVENT_LAYER: "rg-object-wake-hover-event-layer",
  RG_CAMERA_MASTER_LAYER: "rg-camera-master-layer",
};

const SOURCE_ID = {
  RG_OBJECT_DISPLAY_AREA: "rg-object-display-area",
  RG_OBJECT_TRACKS: "rg-object-tracks",
  RG_OBJECT_POINTS: "rg-object-points",
  RG_CAMERA_MASTERS: "rg-camera-masters",
};

const PLAYBACK_STATUS = {
  PLAY: 1,
  PAUSE: 2,
  REPLAY: 3,
};

const INVALID_SOG = 409.5;

const RG_FB_COLLECTIONS_RADAR_GRID_OBJECTS = "radar_grid_objects";
const RG_FB_COLLECTIONS_AI_CAMERA_CONTROL = "ai_camera_control";
const RG_FB_COLLECTIONS_CAMERA_MOVE_REQUEST = "camera_move_request";
const RG_FB_COLLECTIONS_CAMERA_FOCUS_REQUEST = "camera_focus_request";
const RG_FB_COLLECTIONS_RADAR_CAMERA_MASTER = "radar_camera_master";

const RG_FB_COLLECTIONS = {
  RADAR_GRID_OBJECTS: RG_FB_COLLECTIONS_RADAR_GRID_OBJECTS,
  AI_CAMERA_CONTROL: RG_FB_COLLECTIONS_AI_CAMERA_CONTROL,
  CAMERA_MOVE_REQUEST: RG_FB_COLLECTIONS_CAMERA_MOVE_REQUEST,
  CAMERA_FOCUS_REQUEST: RG_FB_COLLECTIONS_CAMERA_FOCUS_REQUEST,
  RADAR_CAMERA_MASTER: RG_FB_COLLECTIONS_RADAR_CAMERA_MASTER,
};

const RG_WAKE_LINE_POPUP_WRAPPER_CLASS_NAME = "rg-wake-line-popup-wrapper";

const FIXED_POINT_CAMERA_HISTORY = "fixed-point-camera-history";

export default {
  PLAYBACK_AREA_COORDINATES,
  PLAYBACK_AREA_DEFAULT_ZOOM,
  PLAYBACK_OBJECT_TYPE,
  RADAR_GRID_OBJECT_KIND,
  RG_RISK_LEVEL,
  RG_RISK_LEVEL_CANCELED,
  RADAR_GRID_OBJECT_RISK_LEVEL,
  LAYER_ID,
  SOURCE_ID,
  PLAYBACK_STATUS,
  INVALID_SOG,
  RG_FB_COLLECTIONS,
  RG_WAKE_LINE_POPUP_WRAPPER_CLASS_NAME,
  FIXED_POINT_CAMERA_HISTORY,
};
